var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfessionWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.15 91.78",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 86V17.16c1.24-4.36 4.19-5.74 8.28-5.65 7.47.15 14.94 0 22.41 0h1.25V4.18c0-2.61.44-3.28 2.78-4.18h32.72c2.27.89 2.72 1.57 2.72 4.12v7.43h24.9a6.55 6.55 0 015.81 2.85 17.06 17.06 0 011.28 2.77V86c-.44 1.72-1.1 3.39-2.67 4.33a23.45 23.45 0 01-3.71 1.46H6.38a23 23 0 01-3.7-1.46C1.1 89.38.44 87.72 0 86zm28.07-.47h46.11V17.76H28.07zM80.48 17.7v67.87h14.65c.82 0 .86-.5.86-1.12V18.81c0-.89-.3-1.14-1.15-1.14H83.56zm-58.76.06a3.88 3.88 0 00-.46-.06H7.1c-1 0-1 .56-1 1.29v65.22c0 1.26.12 1.38 1.36 1.38h13.36c.29 0 .57 0 .9-.06zM64 6.27H38.17v5.21H64z",
    fill: "#878789",
    "data-name": "Capa 1"
  }))));
}

export default SvgProfessionWork;